<template>
	<client-page>
        <sub-visual-full bg="/images/sub/visual/sv4-3.jpg">
            <div class="text-ani-wrap mb-30 mb-lg-54">
                <div class="text-ani mb-14 mb-lg-28">
                    <h2 class="font-weight-bold font-size-40 font-size-md-54 font-size-lg-80 line-height-1">
                        Fundraiser
                    </h2>
                </div>
                <div class="text-ani">
                    <h3 class="tit font-weight-bold line-height-1">
                        펀드레이저
                    </h3>
                </div>
            </div>
            <p class="tit-txt color-grey-d">
                NGO의 가치와 의미를 알리는 <br>
                기금 모금 활동가
            </p>
        </sub-visual-full>

        <section class="section bg-grey">
            <v-container>
                <div class="video-wrap mb-30 mb-lg-54">
                    <iframe src="https://www.youtube.com/embed/SWy8xSq9-o8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div class="mb-30 mb-lg-54">
                    <p class="tit-txt text-center mb-8 mb-lg-24">
                        펀드레이저는 개인과 단체의 기부가 이뤄지도록 기획하고 독려하는 기금모금 활동 전문가로서 공공의 가치를 일깨우고 <br class="d-none d-xl-block">
                        사회의 긍정적인 변화에 관심을 갖도록 하며 후원자를 유치합니다. 사회의 성숙과 함께 건강한 기부문화가 <br class="d-none d-xl-block">
                        활성화될수록 전문 펀드레이저의 수요와 필요성이 증가하고 있습니다. 
                    </p>
                    <p class="tit-txt text-center mb-8 mb-lg-24">
                        세일즈웍스는 NGO 단체를 전문적으로 담당하는 브랜드, 서포트웍스를 운영하고 있습니다.
                    </p>
                </div>
                <div class="video-wrap mb-30 mb-lg-54">
                    <iframe src="https://www.youtube.com/embed/tPvczyeH7YI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </v-container>
        </section>

        <section class="section">
            <v-container>
                <v-row>
                    <v-col cols="7" sm="5" md="3" class="mx-auto mb-10 mb-md-0" data-aos="fade-right">
                        <div class="w-100 h-100 d-md-flex align-center pr-md-12 pr-lg-24">
                            <v-img src="/images/supportworks-ci.svg" class="w-100"></v-img>
                        </div>
                    </v-col>
                    <v-col cols="12" md="9" data-aos="fade-left">
                        <div class="w-100 h-100 pl-md-24 pl-lg-60 border-md-start border-color-light">
                            <p class="page-text--sm color-grey-7 mb-14 mb-lg-26">
                                <strong class="font-weight-bold color-black">서포트웍스는 <span class="color-secondary">매년 약 3만명</span>의 후원자를 NGO 단체와 연결하고 있습니다.</strong> <br>
                                서포트웍스의 펀드레이저는 검증된 국내외 NGO 단체와 함께하고, 나아가 다른 펀드레이저의 멘토가 되어 트레이닝 <br class="d-none d-lg-block">
                                스킬, 매니징 역량을 키우며 커리어 확장이 가능합니다.
                            </p>
                            <p class="font-size-12 font-size-lg-16 color-grey-9 mb-20 mb-lg-30">
                                * 서포트웍스 홈페이지를 방문하시면 펀드레이저에 대해 더 자세히 확인하실 수 있습니다.
                            </p>
                            <arrow-btn tit="서포트웍스 홈페이지" color="secondary" link="https://www.supportworks.kr/" type="href"></arrow-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="section bg-grey section-top-image" style="background-image: url(/images/sub/recruitment/fundlaser/s2-bg.jpg); background-position: right 25% top;">
            <v-container>
                <div class="tit-wrap text-left">
                    <h3 class="tit color-white font-weight-bold">
                        왜 <br>
                        서포트웍스와 <br>
                        함께할까요?
                    </h3>
                </div>
                <v-row justify="center">
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/recruitment/fundlaser/s2-img1.jpg"
                        tit="NGO의 가치 실현과 진정한 보람"
                        titWidth="w-xl-40">

                            <p class="font-size-14 font-size-xl-18 line-height-15 color-grey-7">
                                NGO 단체의 얼굴이 되어 보다 나은 세상을
                                만드는 역할을 합니다. 서포트웍스는 올바른
                                가치를 옹호하고 공공성을 지향하는 국내외
                                NGO 단체와 일해왔습니다. <br class="d-none d-xl-block">
                                구호활동에 대한 깊이 있는 이해와 진심,
                                그리고 책임감을 가진 펀드레이저로서 공공의
                                가치를 실현하는 것에 큰 자부심을 느낄 수
                                있습니다. 
                            </p>

                        </image-on>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/recruitment/fundlaser/s2-img2.jpg"
                        tit="다양한 사람들과 깊이 있는 소통"
                        titWidth="w-xl-50">

                            <p class="font-size-14 font-size-xl-18 line-height-15 color-grey-7">
                                사람들과 소통하며 윤리와 신뢰를 기반으로
                                마음을 움직일 수 있어야 합니다. 
                                경청하는 자세, 이해력, 공감력을 갖춘
                                펀드레이저를 통해 NGO 캠페인을 접한
                                시민들의 인식과 참여 증대는 사회 문제
                                해결의 출발점이 됩니다.
                            </p>

                        </image-on>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/recruitment/fundlaser/s2-img3.jpg"
                        tit="전문가로 성장하는 체계적 교육 시스템"
                        titWidth="w-xl-50">

                            <p class="font-size-14 font-size-xl-18 line-height-15 color-grey-7">
                                전문 교육 시스템과 1:1 맞춤 트레이닝으로
                                인성과 실력을 갖춘 전문 펀드레이저를
                                양성합니다. 정기 세미나, 해외 워크숍, NGO
                                단체의 교육 및 온라인 교육 프로그램 등
                                전문성을 위한 다방면의 교육을 지원합니다.
                                경력과 무관하게 진정성과 열정을 가진
                                인재라면 전문 펀드레이저로 성장 가능합니다.
                            </p>

                        </image-on>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/recruitment/fundlaser/s2-img4.jpg"
                        tit="자율적 시간 관리 & 정당한 보상"
                        titWidth="w-xl-62">

                            <p class="font-size-14 font-size-xl-18 line-height-15 color-grey-7">
                                펀드레이저는 열정과 헌신, 확고한 윤리관이
                                필요한 전문 직업입니다. 공익을 추구하는
                                일이니만큼 지속성과 성취감이 중요합니다. 
                                프리랜서 형태로 일하며 노력에 대한 정당한
                                보상을 받습니다. 역량과 환경에 맞게
                                자유롭게 시간을 관리하며 자기 주도적으로
                                일할 수 있습니다. 
                            </p>

                        </image-on>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/recruitment/fundlaser/s2-img5.jpg"
                        tit="다양한 커리어 확대 지원"
                        titWidth="w-xl-50">

                            <p class="font-size-14 font-size-xl-18 line-height-15 color-grey-7">
                                국내외 다양한 NGO 단체를 깊이 있게
                                경험하면서 전문 직업인 펀드레이저로서의
                                커리어를 쌓게 됩니다. <br class="d-none d-xl-block">
                                본인이 추구하는 방향에 따라 트레이너로
                                성장하거나, 팀을 운영하며 커리어를 확장하고
                                싶다면 서포트웍스의 다양한 지원을 받을 수
                                있습니다.
                            </p>

                        </image-on>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/recruitment/fundlaser/s2-img6.jpg"
                        tit="사람 중심의 수평적인 문화"
                        titWidth="w-xl-50">

                            <p class="font-size-14 font-size-xl-18 line-height-15 color-grey-7">
                                서포트웍스는 서로의 성장을 응원하고
                                이끌어주는 사람 중심의 문화로 수평적이고
                                열린 소통을 지향합니다. <br class="d-none d-xl-block">
                                사람과 사람을 이어주는 따뜻한 직업인
                                펀드레이저가 즐겁게 일할 수 있는 기업
                                문화와 환경이 조성되어 있습니다. 
                            </p>

                        </image-on>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">
                        홍보채널
                    </h3>
                    <p class="tit-txt">
                        전국 지점을 바탕으로 다양한 채널에서 캠페인 활동이 가능합니다.
                    </p>
                </div>
                <v-row no-gutters class="text-center">
                    <v-col cols="12" sm="4" class="mb-20 mb-sm-0">
                        <v-img src="/images/sub/recruitment/fundlaser/s3-img1.jpg" class="w-100 mb-16 mb-lg-30"></v-img>
                        <h5 class="tit-txt font-weight-bold color-secondary mb-2 mb-lg-0" data-aos="fade-down">
                            대중 캠페인
                        </h5>
                        <p class="font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16" data-aos="fade-up">
                            인구밀집지역
                        </p>
                        <p class="page-text--sm">
                            상업지구, 번화가와 같이 유동인구가 <br class="d-none d-lg-block">
                            많은 지역에서 캠페인을 진행하며 <br class="d-none d-lg-block">
                            NGO 단체를 알리고 후원자를 개발
                        </p>
                    </v-col>
                    <v-col cols="12" sm="4" class="mb-20 mb-sm-0">
                        <v-img src="/images/sub/recruitment/fundlaser/s3-img2.jpg" class="w-100 mb-16 mb-lg-30"></v-img>
                        <h5 class="tit-txt font-weight-bold color-secondary mb-2 mb-lg-0" data-aos="fade-down">
                            이벤트 행사
                        </h5>
                        <p class="font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16" data-aos="fade-up">
                            축제, 행사, 쇼핑몰, 백화점 등 
                        </p>
                        <p class="page-text--sm">
                            NGO 캠페인을 효과적으로 <br class="d-none d-lg-block">
                            전달할 수 있는 이벤트 장소에서 <br class="d-none d-lg-block">
                            캠페인 진행
                        </p>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-img src="/images/sub/recruitment/fundlaser/s3-img3.jpg" class="w-100 mb-16 mb-lg-30"></v-img>
                        <h5 class="tit-txt font-weight-bold color-secondary mb-2 mb-lg-0" data-aos="fade-down">
                            B2B / B2C
                        </h5>
                        <p class="font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16" data-aos="fade-up">
                            일반 기업 및 공공기관
                        </p>
                        <p class="page-text--sm">
                            오피스 밀집 지역 대상으로 <br class="d-none d-lg-block">
                            밀도 있게 캠페인을 진행하여 <br class="d-none d-lg-block">
                            NGO 단체 홍보 
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </section>

	</client-page>
</template>

<script>

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualFull from "@/components/client/sub/sub-visual-full.vue";
import ImageOn from "@/components/client/sub/sub-image-on.vue";
import ArrowBtn from "@/components/client/sub/arrow-btn.vue";

export default{
	components: {
        ClientPage,
        SubVisualFull,
        ImageOn,
        ArrowBtn,
    },
    mounted() {
    },
    data() {
        return {
        }
    },
}
</script>
